import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";

import commoncss from "./../../css/common.module.css";
import libcss from "../../css/library.module.css";
import buttoncss from "./../../css/button.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import adminPortalCss from "../../css/adminportal.module.css";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const OverrideFSModal = ({ setShowOverrideModal }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    console.log("selectedItem", selectedItem);
  }, [selectedItem]);
  const data = [...Array(12)].map((_, i) => ({
    id: i + 1,
    label: `FS ${i + 1}`,
  }));

  const [checked, setChecked] = useState([]);

  const handleChange = (id, isChecked) => {
    setChecked((prev) =>
      isChecked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };
  return (
    <Modal
      width="50%"
      // minHeight="500px"
      title="Override"
      bodycss={commoncss.unsetPadding}
      headerActions={<CloseIcon onClick={() => setShowOverrideModal(false)} />}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowOverrideModal(false)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Continue"
            // onClick={restoreSelectedItems}
          />
        </>
      }
    >
      <div style={{ padding: "10px 50px" }}>
        <div className={libcss.overrideNote}>
          This Template is linked to{" "}
          <span className={`${commoncss.fw600} ${commoncss.fs16}`}>
            {18} Financial statements
          </span>
          . How would you like to override the changes you have made?
        </div>
        <div
          className={adminPortalCss.radioButtonSection}
          style={{ "justify-content": "center" }}
        >
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="override"
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            className={adminPortalCss.radioSection}
          >
            <FormControlLabel
              value="override_all"
              className={adminPortalCss.radioLabel}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to all"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="override_selected"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to selected"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="dont_override"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Don't Override"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
          </RadioGroup>
        </div>
        {selectedItem === "override_selected" && (
          <div className={`${libcss.selectFsDiv} my-3`}>
            <span className={`${commoncss.primaryLable}`}>
              Select FS to override
            </span>
            <div className={`${libcss.fsGrid} mt-2`}>
              {data.map((item) => (
                <div key={item.id} className={libcss.fsItem}>
                  <input
                    type="checkbox"
                    checked={checked.includes(item.id)}
              onChange={(e) => handleChange(item.id, e.target.checked)}
                  />
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OverrideFSModal;
